module.exports = __webpack_public_path__ + "media/images/athletes/2820-7dd98de189866d959cb6f0df4da1e018.png";